import React from 'react';
import {
    usePropertyFetching,
    usePropertyRoomDetail,
} from '../../../contextsProperty/ContextProperties';
import Card from '../../../../muiComponents/Card';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import GridChild from '../../../../muiComponents/GridChild';
import Grid from '../../../../muiComponents/Grid';
import SwitchInput from '../../../../muiComponents/switchInput/SwitchInput';
import LoadingTab from '../LoadingTab';
import Title from '../Title';
import { doubleColumnGrid } from '../../../../utils/property/propertyUtils';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../utils/commonVariables/grid';

export default function MainRoomInfo() {
    const {
        name,
        size,
        adultsOnly,
        freeBaby1,
        freeBaby2,
        handleRoomInputChange,
    } = usePropertyRoomDetail();
    const { isFetching } = usePropertyFetching();

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <div>
                <Title
                    as='h1'
                    text={'room_set_up'}
                    className='text-align-center'
                />
            </div>
            <Card className='your-properties__form'>
                <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing40}>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='room_name'
                            handleChange={e => {
                                handleRoomInputChange('name', e.target.value);
                            }}
                            value={name}
                            name='name'
                            type='text'
                            variant='outlined'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='square_meter'
                            handleChange={e => {
                                console.log(e.target.value);
                                handleRoomInputChange(
                                    'size',
                                    parseInt(e.target.value) || 0
                                );
                            }}
                            value={size}
                            name='size'
                            type='number'
                            variant='outlined'
                        />
                    </GridChild>
                </Grid>
                <SwitchInput
                    checked={!adultsOnly}
                    onChangeMethod={e => {
                        const checked = e.target.checked;
                        handleRoomInputChange('adultsOnly', !checked);

                        if (!checked) {
                            handleRoomInputChange('freeBaby1', false);
                            handleRoomInputChange('freeBaby2', false);
                        }
                    }}
                    labelText={'accept_kids'}
                    style={{ marginBlock: '20px' }}
                />
                {adultsOnly ? (
                    ''
                ) : (
                    <Grid
                        columnSpacing={gridSpacing30}
                        rowSpacing={gridSpacing40}
                    >
                        <GridChild gridProps={doubleColumnGrid}>
                            <SwitchInput
                                checked={freeBaby1}
                                onChangeMethod={e => {
                                    const checked = e.target.checked;
                                    handleRoomInputChange('freeBaby1', checked);
                                    if (!checked) {
                                        handleRoomInputChange(
                                            'freeBaby2',
                                            false
                                        );
                                    }
                                }}
                                labelText={'free_baby'}
                                style={{ marginBottom: '20px' }}
                            />
                        </GridChild>
                        {freeBaby1 && (
                            <GridChild gridProps={doubleColumnGrid}>
                                <SwitchInput
                                    checked={freeBaby2}
                                    onChangeMethod={e => {
                                        handleRoomInputChange(
                                            'freeBaby2',
                                            e.target.checked
                                        );
                                    }}
                                    labelText={'free_baby_2'}
                                    style={{ marginBottom: '20px' }}
                                />
                            </GridChild>
                        )}
                    </Grid>
                )}
            </Card>
        </div>
    );
}
